import session from 'modules/session';
import i18n from 'components/LanguageSelector/modules';
import login from 'routes/Auth/Login/modules';
import logout from 'routes/Auth/Logout/modules';
import signup from 'routes/Auth/Signup/modules';
import companies from 'routes/PreHome/modules';
import company from 'routes/Home/modules';
import mentoring from 'routes/Mentoring/modules';
import editInfo from 'routes/EditInfo/modules';
import forms from 'components/InternalForm/modules';
import performance from 'routes/Performance/modules';
import captable from 'routes/Captable/modules';
import { organizationReducer } from 'modules/investmentAssets/modules';
import notifications from './conf02';
import global from '../global';

export default {
  session: (state, action) => {
    const sessionState = session(state, action);
    return organizationReducer(sessionState, action);
  },
  i18n,
  login,
  logout,
  signup,
  global,
  notifications,
  companies,
  company,
  mentoring,
  forms,
  performance,
  editInfo,
  captable,
};
